/**
 * Display titles for survey codes.
 *
 * survey-api's definition carries a code (`RIA_FIRM`, `FA`) and its sections
 * carry titles, but the survey itself has no display name on the respondent
 * contract — so the list of published rankings lives here until it does.
 */
const TITLES: Record<string, string> = {
  RIA_FIRM: 'Top RIA Firms',
  FA: 'Top Financial Advisors',
  FSP: 'Top Financial Security Professionals',
  TEAMS: 'Top Wealth Advisor Teams'
};

export function surveyTitle(surveyCode: string): string {
  return TITLES[surveyCode] ?? surveyCode;
}
